<a *ngIf="enableNewReactApp" [href]="homeUrl" target="_self" class="logo-container" aria-label="Go to home">
  <ng-container *ngTemplateOutlet="logos"></ng-container>
</a>

<a *ngIf="!enableNewReactApp" routerLink="/home" class="logo-container" aria-label="Go to home">
  <ng-container *ngTemplateOutlet="logos"></ng-container>
</a>

<ng-template #logos>
  <img src="/assets/zpax-mini-logo.png" alt="Z.PAX" class="zpax-logo">
  <span aria-hidden="true" class="logo-divider"></span>
  <img src="/assets/rc-logo.png" alt="Rehab Connect" class="rc-logo">
</ng-template>
